var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('Item',{attrs:{"list":_vm.czNaces,"label":_vm.$t('workers.cz_nace')},on:{"add":_vm.addCzNace,"remove":_vm.removeCzNace,"edit":_vm.changeCzNace}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }